import type { Store } from 'redux';
import { configureStore } from '@reduxjs/toolkit';
import { createWrapper, type MakeStore } from 'next-redux-wrapper';

import { reducer } from './reducer';
import type { PaleState } from '@/interfaces';

// biome-ignore lint/suspicious/noExplicitAny: This was set before biome was added
const makeStore: MakeStore<any> = ({ reduxWrapperMiddleware }) =>
    configureStore({
        reducer,
        middleware: (getDefaultMiddleware) => [...getDefaultMiddleware(), reduxWrapperMiddleware],
    });

export const wrapper = createWrapper<Store<PaleState>>(makeStore, { debug: false });
